import { render, staticRenderFns } from "./PhoneMessageBox.vue?vue&type=template&id=0fa22882&scoped=true&"
import script from "./PhoneMessageBox.vue?vue&type=script&lang=js&"
export * from "./PhoneMessageBox.vue?vue&type=script&lang=js&"
import style0 from "./PhoneMessageBox.vue?vue&type=style&index=0&id=0fa22882&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa22882",
  null
  
)

export default component.exports